const KnownCreatorTypes: Record<string, string> = {
  auth0: 'Portal User',
  reznor_partner_token_id: 'Clearcover',
  reznor_customer: 'Mobile App',
  system: 'System Generated',
};

export const selectCreatedBy = (createdBy: string): string => {
  const creatorType = createdBy.split('|')[0];
  return KnownCreatorTypes[creatorType] || 'Unknown';
};

export type VersionType =
  | 'bind'
  | 'mid_term'
  | 'renewal'
  | 'renewal_quote'
  | 'cancellation'
  | 'reinstatement';

export const VERSION_TYPE_LABELS: Record<VersionType, string> = {
  bind: 'Bind',
  mid_term: 'Mid-Term Endorsement',
  renewal: 'Renewal',
  renewal_quote: 'Renewal Quote',
  cancellation: 'Cancellation',
  reinstatement: 'Reinstatement',
};

export type DraftStatusCode = 'PENDING' | 'APPLIED' | 'TERMINATED';

export interface TimelineDraft {
  id: string;
  effectiveDate?: string;
  draftType: VersionType;
  status: DraftStatusCode;
  createdBy: string;
  createdAt: string;
}

export interface TimelineVersion {
  id: string;
  policyId: string;
  policyTermId: string;
  versionStartDate: string;
  versionNumber: number;
  transactionAt: string;
  createdAt: string;
  createdBy: string;
  dataSchemaVersion: number;
  status: string;
  versionType: VersionType;
  drafts: TimelineDraft[];
}

export interface TimelineTerm {
  id: string;
  termNumber: number;
  termLength: number;
  termStatus: string;
  termStatusDetails: string;
  termStatusDetailsList: string[];
  effectivePeriod: {
    startAt: string;
    endAt: string;
  };
  versions: TimelineVersion[];
}

export type TimelineData = TimelineTerm[];

/**
 * Wire-level shape of the /policies/{id}/timeline response — mirrors the
 * cc-typescript GetPolicyTimelineResponse. Carries the feature-flag boolean
 * (DLC-138) alongside the terms payload so core-app can hide the Policy
 * Timeline tab when the flag is off (CORE_SHOW_POLICY_TIMELINE env var on
 * policy-frontend-api).
 */
export interface TimelineApiResponse {
  showTimeline: boolean;
  terms: TimelineData;
}
